"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Setup/SetupGroups/Audio.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _videoCallSoundEffects = require('web/services/videoCallSoundEffects');










const AudioSetupGroup = ({
  audioStream,
  audioInDevices,
  currentMicDeviceId,
  setCurrentMicDeviceId,
}) => {
  const handleMicChange = (e) =>
    setCurrentMicDeviceId(e.target.value)

  const areAnyDevicesPresent = audioInDevices && audioInDevices.length

  return (
    _react2.default.createElement('div', { className: "meeting--setup--group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}
      , _react2.default.createElement('div', { className: "meeting--setup--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
        , _react2.default.createElement('h3', { className: "meeting--setup--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}, "Microphone")
        , _react2.default.createElement('div', { className: "meeting--setup--section-main", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
          , _react2.default.createElement('select', {
            value: currentMicDeviceId,
            onChange: handleMicChange,
            className: "meeting--setup--select",
            disabled: !areAnyDevicesPresent, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}

            ,  areAnyDevicesPresent
              ? audioInDevices.map(({ deviceId, label }, i) => (
                  _react2.default.createElement('option', {
                    key: deviceId,
                    value: deviceId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}

                    ,  label || `Mic #${i + 1}` 
                  )
              ))
              : _react2.default.createElement('option', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}, "N/A")
            
          )
          ,  audioStream &&
            _react2.default.createElement('div', { className: "meeting--setup--audio--mic-check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}} )
          
        )
        ,  !audioStream && (
          _react2.default.createElement('div', { className: "meeting--setup--issues-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
            , _react2.default.createElement('span', { className: "meeting--issue--warn-sign", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}, "No audio detected."  )
          )
        ) 
      )

      , _react2.default.createElement('div', { className: "meeting--setup--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
        , _react2.default.createElement('h3', { className: "meeting--setup--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}, "Speakers")
        , _react2.default.createElement('div', {
          onClick: _videoCallSoundEffects.playSoundCheck,
          className: "meeting--setup-audio--sound-test-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}

          , _react2.default.createElement('img', { src: "/assets/icons/video/speaker-purple.svg", alt: "🔊", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}} )
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}, "Test audio" )
        )
        , _react2.default.createElement('span', { className: "meeting--setup-audio--sound-test-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}, "You can change your audio output settings in your system preferences."

        )
      )
    )
  )
}

exports. default = AudioSetupGroup
